module.exports = __webpack_public_path__ + "img/t1.27ac35a1.jpg";